import { render, staticRenderFns } from "./HtmlEditorTiptapToolbarCode.vue?vue&type=template&id=5b8d47dd&"
import script from "./HtmlEditorTiptapToolbarCode.vue?vue&type=script&lang=js&"
export * from "./HtmlEditorTiptapToolbarCode.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditorTiptapToolbarCode.vue?vue&type=style&index=0&id=5b8d47dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports